import React, { Component } from 'react'
import PropTypes from 'prop-types'

import styles from './Hero.module.styl'

let autoLoop = null

class Hero extends Component {
  static propTypes = {
    backgroundColor: PropTypes.string,
    overlayContent: PropTypes.node,
    slideStyles: PropTypes.object,
    images: PropTypes.arrayOf(PropTypes.shape({
      alt: PropTypes.string,
      image: PropTypes.string.isRequired
    })).isRequired,
  }

  state = {
    currentImageIndex: 0
  }

  componentDidMount = () => {
    this._autoLoop('start')
  }

  componentWillUnmount = () => {
    this._autoLoop('stop')
  }

  _nextSlide = () => {
    this.setState({
      currentImageIndex: this.state.currentImageIndex === (this.props.images.length - 1)
        ? 0
        : this.state.currentImageIndex + 1
    })
  }

  _autoLoop = (state) => {
    if (state === 'start') {
      autoLoop = setInterval(() => {
        this._nextSlide()
      }, 12000)
    } else {
      clearInterval(autoLoop)
    }

    return null
  }

  _renderImages = () => {
    return this.props.images.map((image, index) => (
      <div
        key={index}
        className={[styles.image, this.state.currentImageIndex === index ? styles.active : null].join(' ')}
        style={{ backgroundImage: `url(${image.image})`, ...this.props.slideStyles }}
      />
    ))
  }

  render() {
    return (
      <header className={styles.hero} style={{ backgroundColor: this.props.backgroundColor }}>
        <div className={styles.overlayContent}>{this.props.overlayContent}</div>
        {this._renderImages()}
      </header>
    )
  }
}

export default Hero



// WEBPACK FOOTER //
// ./src/components/PageHome/Hero/Hero.js